export { Angular } from './angular';
export { CaptureConsole } from './captureconsole';
export { Debug } from './debug';
export { Dedupe } from './dedupe';
export { Ember } from './ember';
export { ExtraErrorData } from './extraerrordata';
export { ReportingObserver } from './reportingobserver';
export { RewriteFrames } from './rewriteframes';
export { SessionTiming } from './sessiontiming';
export { Tracing } from './tracing';
export { Transaction } from './transaction';
export { Vue } from './vue';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/integrations/esm/index.js
// module id = M6om
// module chunks = 0